export const useModals = () =>
  useState('modals', () => ({
    video: false,
    videoUrl: ''
  }))

export default function () {
  const modals = useModals()

  return {
    isVideoVisible: computed(() => modals.value.video),
    videoUrl: computed(() => modals.value.videoUrl),
    showVideo: (url: string) => {
      modals.value.videoUrl = url
      modals.value.video = true
    },
    hideVideo: () => {
      modals.value.video = false
      modals.value.videoUrl = ''
    }
  }
}
